import React from 'react';
import { Box, Typography, Chip, Divider } from '@mui/material';
import ElevatedContentCard from '../../../../components/containers/ElevatedContentCard';

const SummaryCard = ({ content }) => {
  return (
    <ElevatedContentCard sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
        <Typography variant="h6" fontWeight="600">
          Collection Details
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Chip label={content.status} color="primary" size="small" />
          <Chip label={content.type?.replace('_', ' ')} variant="outlined" size="small" />
          {content.schoolLevel && (
            <Chip label={content.schoolLevel?.replace('_', ' ')} variant="outlined" size="small" />
          )}
        </Box>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Typography variant="body1" color="text.secondary" paragraph>
        {content.description || 'No description available for this collection.'}
      </Typography>

      <Box sx={{ display: 'flex', gap: 4, mt: 3 }}>
        <Box>
          <Typography variant="caption" color="text.secondary">
            Created At
          </Typography>
          <Typography variant="body2">
            {new Date(content.createdAt).toLocaleDateString()}
          </Typography>
        </Box>
        {content.createdBy && (
          <Box>
            <Typography variant="caption" color="text.secondary">
              Author
            </Typography>
            <Typography variant="body2">
              {content.createdBy}
            </Typography>
          </Box>
        )}
      </Box>
    </ElevatedContentCard>
  );
};

export default SummaryCard;
